import Joi from '@hapi/joi'

export const AttendanceReportDailySchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
        
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity required`,
    }),
    date: Joi.string().invalid("").label("Date").messages({
        "any.invalid": `Date required`,
    }),
    divisionID: Joi.number().label("Division").messages({
        "any.invalid": `Select Division`,
        "any.required": `Division required`
    }),
}